// Right-anchored slide-over panel — the console's "dialog" pattern for
// create/edit forms and detail views (mirrors solya-app's SlideOverPanel).

import type { ReactNode } from "react"
import { useEffect } from "react"

export function Drawer({
  open,
  title,
  subtitle,
  onClose,
  footer,
  children
}: {
  open: boolean
  title: string
  subtitle?: string
  onClose: () => void
  footer?: ReactNode
  children: ReactNode
}) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose()
    }
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [open, onClose])

  if (!open) return null
  return (
    <>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: Escape is handled globally above */}
      <div className="drawer__scrim" onClick={onClose} />
      {/* biome-ignore lint/a11y/useSemanticElements: a non-modal side panel, not a native <dialog> */}
      <aside className="drawer" role="dialog" aria-label={title}>
        <header className="drawer__header">
          <div>
            <strong>{title}</strong>
            {subtitle ? <div className="subtitle">{subtitle}</div> : null}
          </div>
          <button type="button" className="btn btn--ghost btn--sm" onClick={onClose}>
            Fermer
          </button>
        </header>
        <div className="drawer__body">{children}</div>
        {footer ? <footer className="drawer__footer">{footer}</footer> : null}
      </aside>
    </>
  )
}
